import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "./supabaseClient";

const AuctionSetup = ({ user }) => {
  const [auctionName, setAuctionName] = useState("");
  const [description, setDescription] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleCreateAuction = async () => {
    if (!user?.id) {
      setErrorMessage("User not authenticated. Please log in and try again.");
      return;
    }

    if (!auctionName.trim()) {
      setErrorMessage("Please enter an auction name.");
      return;
    }

    setIsLoading(true);
    setErrorMessage("");

    try {
      const auctionCode = Math.random().toString(36).substring(2, 10);

      const { error } = await supabase
        .from("auctions")
        .insert({
          auction_name: auctionName,
          description: description.trim(),
          auction_code: auctionCode,
          user_id: user.id, // Ensure user ID is properly provided
        });

      if (error) {
        throw error;
      }

      // Navigate to the admin page if successful
      navigate(`/auction-admin/${auctionCode}`);
    } catch (error) {
      console.error("Error during auction creation:", error.message);
      setErrorMessage("Auction creation failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h1>Set Up Your Auction</h1>
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
      <input
        type="text"
        placeholder="Auction Name"
        value={auctionName}
        onChange={(e) => setAuctionName(e.target.value)}
      />
      <textarea
        placeholder="Description (optional)"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      ></textarea>
      <button onClick={handleCreateAuction} disabled={isLoading}>
        {isLoading ? "Creating..." : "Create Auction"}
      </button>
    </div>
  );
};

export default AuctionSetup;
